<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    }
  },
};
</script>

<template>
  <div class="text-center text-secondary my-5 font-size-14">
    <p class="m-0">{{title||'Chưa có dữ liệu'}}</p>
    <slot></slot>
  </div>
</template>
